import type { FC } from "react";
import type { IStyledComponent } from "styled-components";
import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { CountryFilter } from "app/components/filters-bar/country-filter/CountryFilter";
import * as utils from "app/components/filters-bar/utils";
import type { ICountryObject } from "app/services/CountryService";
import { CountryFilterWrapper } from "app/components/filters-bar/country-filter/StyledComponent";
import { SWReactCountryIcons } from "@similarweb/icons";
import { allTrackers } from "app/services/track/track";

const { carbon } = colorsPalettes;

const DefaultContainer = styled(CountryFilterWrapper)`
    height: 40px;
    border: 1px ${carbon[50]} solid;
    border-radius: 3px;
    background-color: ${carbon[0]};
`;

interface IStartPageCountryFilter {
    selectedCountry: ICountryObject;
    onChangeSelectedCountry: (country: ICountryObject) => void;
    availableCountries: Array<ICountryObject>;
    renderButtonComponent?(selectedCountry: ICountryObject): React.ReactNode;
    appendTo?: string;
    Container?: IStyledComponent<"web", any>;
}

const DROPDOWN_POPUP_PLACEMENT = "ontop-left";
const WIDTH = "240px";
const HEIGHT = "40px";
const DROPDOWN_POPUP_WIDTH = 240;

const StartPageCountryFilter: FC<IStartPageCountryFilter> = ({
    selectedCountry,
    onChangeSelectedCountry,
    availableCountries,
    renderButtonComponent,
    appendTo,
    Container = DefaultContainer,
}) => {
    const changeCountry = (country) => {
        allTrackers.dispatchTrackEvent("Drop Down", "click", `Header/Country Filter/${country.text}`);

        onChangeSelectedCountry(country);
    };

    return (
        <Container>
            <CountryFilter
                dropdownPopupPlacement={DROPDOWN_POPUP_PLACEMENT}
                width={WIDTH}
                height={HEIGHT}
                dropdownPopupWidth={DROPDOWN_POPUP_WIDTH}
                availableCountries={availableCountries}
                selectedCountryIds={{
                    [selectedCountry?.id]: true,
                }}
                changeCountry={changeCountry}
                renderButtonComponent={renderButtonComponent}
                appendTo={appendTo}
            />
        </Container>
    );
};

export default StartPageCountryFilter;

const CountryFilterContainer = styled.span``;

const ButtonContainer = styled.span`
    cursor: pointer;
    display: flex;
    gap: 8px;
    ${setFontVariant("chip1", carbon[300])}
`;
interface CountryFiilterWithIconAndNameOnlyProps {
    country: ICountryObject;
    setCountry: (country: ICountryObject) => void;
    appendTo?: string;
}

export const CountryFiilterWithIconAndNameOnly: FC<CountryFiilterWithIconAndNameOnlyProps> = ({
    country,
    setCountry,
    appendTo,
}) => {
    const renderButtonComponent = (selectedCountry: ICountryObject) => {
        const { id, text } = selectedCountry;
        return (
            <ButtonContainer>
                <SWReactCountryIcons
                    countryCode={id}
                    size={"xs"}
                />
                {text}
            </ButtonContainer>
        );
    };
    return (
        <StartPageCountryFilter
            selectedCountry={country}
            onChangeSelectedCountry={setCountry}
            availableCountries={utils.getCountries()}
            renderButtonComponent={renderButtonComponent}
            appendTo={appendTo}
            Container={CountryFilterContainer}
        />
    );
};
